module.exports = __webpack_public_path__ + "static/media/callbreak.73848bbc.webp";